/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  OrganizationDto,
} from '../models/index';
import {
    OrganizationDtoFromJSON,
    OrganizationDtoToJSON,
} from '../models/index';

/**
 * OrganizationsAdminApi - interface
 * 
 * @export
 * @interface OrganizationsAdminApiInterface
 */
export interface OrganizationsAdminApiInterface {
    /**
     * Creates request options for organizationsAdminGetAllOrganizationsGET without sending the request
     * @throws {RequiredError}
     * @memberof OrganizationsAdminApiInterface
     */
    organizationsAdminGetAllOrganizationsGETRequestOpts(): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsAdminApiInterface
     */
    organizationsAdminGetAllOrganizationsGETRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OrganizationDto>>>;

    /**
     */
    organizationsAdminGetAllOrganizationsGET(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OrganizationDto>>;

}

/**
 * 
 */
export class OrganizationsAdminApi extends runtime.BaseAPI implements OrganizationsAdminApiInterface {

    /**
     * Creates request options for organizationsAdminGetAllOrganizationsGET without sending the request
     */
    async organizationsAdminGetAllOrganizationsGETRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/OrganizationsAdmin`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async organizationsAdminGetAllOrganizationsGETRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OrganizationDto>>> {
        const requestOptions = await this.organizationsAdminGetAllOrganizationsGETRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OrganizationDtoFromJSON));
    }

    /**
     */
    async organizationsAdminGetAllOrganizationsGET(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OrganizationDto>> {
        const response = await this.organizationsAdminGetAllOrganizationsGETRaw(initOverrides);
        return await response.value();
    }

}
